const getComponentsData = (turretPackage, chassisPackage, enginePackage, radioPackage, gunPackage) => {
    let componentsDataMapping = {
        engine: {packageIndex: enginePackage},
        turret: {packageIndex: turretPackage},
        gun: {packageIndex: gunPackage},
        radio: {packageIndex: radioPackage},
        chassis: {packageIndex: chassisPackage},
    };
    let unlock_progress = vehicle.unlock_progression;

    Object.keys(unlock_progress).map(moduleName => {
        let moduleKeyName = moduleName === "chassis" ? moduleName : moduleName.slice(0, moduleName.length - 1);
        if(moduleName === "guns") {
            let index_value = componentsDataMapping.gun.packageIndex;
            let gunName = unlock_progress[moduleName][index_value].name;
            let componentData = vehicle.guns[gunName];
            let turret_index_value = componentsDataMapping.turret.packageIndex;
            let turretName = unlock_progress["turrets"][turret_index_value].name;
            // if gun_name not in turrets dict, then incompatible, and set to default gun reload_time
            // hard turrets0 key until refined 7x6 implementation, note if-logic moduleKeyName line 42-44,
            // note PackageButton.jsx tank_module variable line 34
            // let gunTurretCompatibility = vehicle.data["turrets0"][turretName].guns[gunName];
            for(let t of ["turrets0", "turrets1", "turrets2", "turrets3"]) {
                if(vehicle.data[t] && vehicle.data[t][turretName]) {
                    let gunTurretCompatibility = vehicle.data[t][turretName].guns[gunName];
                    if(gunTurretCompatibility){
                        componentData = vehicle.data[t][turretName].guns[gunName];
                    }
                }
            }
            componentsDataMapping[moduleKeyName] = componentData;
        } else {
            let index_value = componentsDataMapping[moduleKeyName].packageIndex;
            let componentName = unlock_progress[moduleName][index_value].name;
            if(moduleKeyName == "turret") {
                for(let t of ["turrets0", "turrets1", "turrets2", "turrets3"]) {
                    if(vehicle.data[t]) {
                        if(vehicle.data[t][componentName]) {
                            moduleName = t;
                        }
                    }
                }
            }
            let componentData = vehicle.data[moduleName][componentName];
            componentsDataMapping[moduleKeyName] = componentData;
        }
    })
    return componentsDataMapping;
};

export function getTankStats(state) {
    let turretData, gunData,  engineData, radioData, chassisData;
    let newTurretData, newGunData, newEngineData, newRadioData, newChassisData;
    let currentComponentsData = getComponentsData(state.turrets.value, state.chassis.value, state.engines.value, state.radios.value, state.guns.value);
    let newComponentsData = getComponentsData(state.turrets.newValue, state.chassis.newValue, state.engines.newValue, state.radios.newValue, state.guns.newValue);

    turretData = currentComponentsData.turret;
    gunData = currentComponentsData.gun;
    engineData = currentComponentsData.engine;
    radioData = currentComponentsData.radio;
    chassisData = currentComponentsData.chassis;

    newTurretData = newComponentsData.turret;
    newEngineData = newComponentsData.engine;
    newGunData = newComponentsData.gun;
    newRadioData = newComponentsData.radio;
    newChassisData = newComponentsData.chassis;

    let configurationComponentsMap = {
        turret: {
            attributes: {
                armory: {label: gettext("turret armor"), separator: "/",unit: gettext("mm"), reverse: false},
                rotation_speed: {label: gettext("traverse speed"), unit: gettext("deg/sec"), reverse: false},
                vision_radius: {label: gettext("view range"), unit: gettext("m"), reverse: false},
                position: {label: gettext("position")},
            }
        },
        gun: {
            attributes: {
                gun_rate: {label: gettext("rate of fire"), unit: gettext("rounds/min"), reverse: false},
                damage: {label: gettext("damage"), separator: "/", unit: gettext("hp !!hitpoints!!"), reverse: false},
                damage_module: {label: gettext("module damage"), separator: "/", unit: gettext("hp !!hitpoints!!"), reverse: false},
                explosion_radius: {label: gettext("blast radius"), separator: "/", unit: gettext("m"), reverse: false},
                damage_per_min: {label: gettext("damage per minute"), unit: gettext("hp/min !!hitpoints per minute!!"), reverse: false},
                piercing_power: {label: gettext("penetration at 100m"), unit: gettext("mm"), separator: "/", reverse: false},
                piercing_power_500m: {label: gettext("penetration at 500m"), unit: gettext("mm"), separator: "/", reverse: false},
                ammo_speed: {label: gettext("ammo max speed"), unit: gettext("m/s"), separator: "/", reverse: false},
                ammo_range: {label: gettext("ammo max range"), unit: gettext("m"), separator: "/", reverse: false},
                ammo_kind: {label: gettext("Shell Type"), unit: "", separator: "/", reverse: false},
                reload_time: {label: gettext("reload time"), unit: gettext("sec"), separator: "/", reverse: true},
                single_fire_cooldown: {label: gettext("single fire cooldown"), unit: gettext("sec"), reverse: true},
                double_shot_cooldown: {label: gettext("double shot cooldown"), unit: gettext("sec"), reverse: true},
                aiming_time: {label: gettext("aiming time"), unit: gettext("sec"), reverse: true},
                aiming_time_siege: {label: gettext("aiming time siege mode*"), unit: gettext("sec"), reverse: true, siege: true},
                aiming_time_turbo: {label: gettext("aiming time turbo mode*"), unit: gettext("sec"), reverse: true},
                shots_per_clip: {label: gettext("shots per clip"), unit: gettext("shots"), reverse: false},
                intra_clip_reload: {label: gettext("intra clip reload"), unit: gettext("sec"), reverse: true},
                shell_autoreloading_time: {label: gettext("shell autoreloading time"), separator: "/", unit: gettext("sec"), reverse: true},
                max_ammo: {label: gettext("ammo capacity"), unit: gettext("rounds")},
                shot_dispersion_radius: {label: gettext("accuracy"), unit: gettext("m"), reverse: true},
                shot_dispersion_radius_siege: {label: gettext("accuracy siege mode*"), unit: gettext("m"), reverse: true, siege: true},
                shot_dispersion_radius_turbo: {label: gettext("accuracy turbo mode*"), unit: gettext("m"), reverse: true},
                dispersion_during_turret_rotation: {label: gettext("accuracy during turret rotation"), unit: gettext("m"), reverse: true},
                dispersion_during_turret_rotation_siege: {label: gettext("accuracy during turret rotation siege mode*"), unit: gettext("m"), reverse: true, siege: true},
                depression: {label: gettext("depression"), unit: gettext("deg"), reverse: false},
                depression_siege: {label: gettext("depression siege mode*"), unit: gettext("deg"), reverse: false, siege: true},
                elevation: {label: gettext("elevation"), unit: gettext("deg"), reverse: false},
                elevation_siege: {label: gettext("elevation siege mode*"), unit: gettext("deg"), reverse: false, siege: true},
                turretYawLimits: {label: gettext("yaw limit"), separator: "/", unit: gettext("deg"), reverse: false},
            }
        },
        engine: {
            attributes: {
                power: {label: gettext("engine power"), unit: gettext("hp !!enginepower!!"), reverse: false},
                power_to_weight: {label: gettext("power/weight ratio"), unit: gettext("hp/t"), separator:"/", reverse: false},
                forward_max: {label: gettext("top forward speed"), unit: gettext("km/h"), reverse: false},
                forward_siege: {label: gettext("top forward speed siege mode*"), unit: gettext("km/h"), reverse: false, siege: true},
                forward_turbo: {label: gettext("top forward speed turbo mode*"), unit: gettext("km/h"), reverse: false},
                forward_rapid: {label: gettext("top forward speed rapid mode*"), unit: gettext("km/h"), reverse: false},
                backward_max: {label: gettext("top reverse speed"), unit: gettext("km/h"), reverse: false},
                backward_siege: {label: gettext("top backward speed siege mode*"), unit: gettext("km/h"), reverse: false, siege: true},
                backward_turbo: {label: gettext("top backward speed turbo mode*"), unit: gettext("km/h"), reverse: false},
                backward_rapid: {label: gettext("top backward speed rapid mode*"), unit: gettext("km/h"), reverse: false},
                fire_chance: {label: gettext("fire chance"), unit: gettext("percent"), reverse: true},
            }
        },
        radio: {
            attributes: {
                distance: {label: gettext("signal range"), unit: gettext("m"), reverse: false}
            }
        },
        chassis: {
            attributes: {
                rotation_speed: {label: gettext("traverse speed"), unit: gettext("deg/sec"), reverse: false},
                terrain_resistance: {label: gettext("terrain resistance"), unit: "", separator:"/", reverse: true},
                turning_angle: {label: gettext("Turning angle"), unit: gettext("deg"), reverse: false},
                switch_on_time_siege: {label: gettext("Switching to Siege mode*"), unit: gettext("sec"), reverse: true, siege: true},
                switch_off_time_siege: {label: gettext("Switching to Travel mode*"), unit: gettext("sec"), reverse: true, siege: true},
                switch_on_time_turbo: {label: gettext("Switching to Turbo mode*"), unit: gettext("sec"), reverse: true},
                switch_off_time_turbo: {label: gettext("Switching to Regular mode*"), unit: gettext("sec"), reverse: true},
                switch_on_time_rapid: {label: gettext("Switching to Rapid mode*"), unit: gettext("sec"), reverse: true},
                switch_off_time_rapid: {label: gettext("Switching to Cruise mode*"), unit: gettext("sec"), reverse: true},
                autoswitch_on_speed_siege: {label: gettext("Siege Mode Auto-Switch Speed*"), unit: gettext("km/h"), reverse: false, siege: true},
                autoswitch_off_speed_siege: {label: gettext("Travel Mode Auto-Switch Speed*"), unit: gettext("km/h"), reverse: false, siege: true},
            }
        }
    };

    let configurationNames = ['engine', 'turret', 'gun', 'radio', 'chassis'];

    configurationNames.map(componentName => {
        let currentComponentData = currentComponentsData[componentName],
            newComponentData = newComponentsData[componentName];

        configurationComponentsMap[componentName].title = currentComponentData.user_string;
        configurationComponentsMap[componentName].newTitle = newComponentData.user_string;
        configurationComponentsMap[componentName].level = currentComponentData.level;
        configurationComponentsMap[componentName].newLevel =  newComponentData.level;

        Object.keys(configurationComponentsMap[componentName].attributes).map(attributeName => {
            if (!("value" in configurationComponentsMap[componentName].attributes[attributeName])) {
                let attributeValue = [], attributeNewValue = [];
                let shellRelated = {
                "damage": true, "damage_module": true,
                "explosion_radius": true,
                "piercing_power": true, "piercing_power_500m": true,
                "ammo_speed": true, "ammo_range": true, "ammo_kind": true
                };
                if ((attributeName in shellRelated) && componentName === "gun") {
                    Object.keys(currentComponentData.shots).map(shotName => {
                        attributeValue[currentComponentData.shots[shotName]["index"]] = currentComponentData.shots[shotName][attributeName];
                    });
                    Object.keys(newComponentData.shots).map(shotName => {
                        attributeNewValue[newComponentData.shots[shotName]["index"]] = newComponentData.shots[shotName][attributeName];
                    });
                } else if(attributeName === "gun_rate") {
                    attributeNewValue = newComponentData[attributeName];
                    attributeValue = currentComponentData[attributeName];
                } else {
                    if (attributeName === "reload_time") {
                        attributeNewValue = newComponentData[attributeName];
                        attributeValue = currentComponentData[attributeName];
                    } else if (attributeName === "power_to_weight") {
                        let fuelTanksData = vehicle.data.fuelTanks;
                        let fuelTankWeight = 0;
                        for(let fuelTank in fuelTanksData) {
                            fuelTankWeight += fuelTanksData[fuelTank].weight;
                        }
                        let vehicleWeight = vehicle.data.weight + chassisData.weight + gunData.weight + turretData.weight + engineData.weight + radioData.weight + fuelTankWeight;
                        let newVehicleWeight = vehicle.data.weight + newChassisData.weight + newGunData.weight + newTurretData.weight + newEngineData.weight + newRadioData.weight + fuelTankWeight;
                        attributeValue = (currentComponentData.power/vehicleWeight)*1000;
                        attributeNewValue = (newComponentData.power/newVehicleWeight)*1000;
                    } else if (attributeName === "fire_chance") {
                        attributeNewValue = 100*newComponentData[attributeName];
                        attributeValue = 100*currentComponentData[attributeName];
                    } else {
                        attributeNewValue = newComponentData[attributeName];
                        attributeValue = currentComponentData[attributeName];
                    }
                }
                configurationComponentsMap[componentName].attributes[attributeName].value = attributeValue;
                configurationComponentsMap[componentName].attributes[attributeName].newValue =  attributeNewValue;
            }
        })
    });

    let statComponentsMap = {
        piercing_power: {
            label: gettext("penetration"),
            unit: gettext("mm"),
            separator: "/",
        },
        damage: {
            label: gettext("damage"),
            separator: "/",
            unit: gettext("hp !!hitpoints!!"),
        },
        hit_points: {
            label: gettext("hit points"),
            unit: gettext("hp !!hitpoints!!"),
            value: vehicle.data.max_health + turretData.max_health,
            newValue: vehicle.data.max_health + newTurretData.max_health,
        },
        max_speed: {
            label: gettext("max speed"),
            unit: gettext("(forward/backward) km/h"),
            separator: "/",
            value: [engineData.forward_max, engineData.backward_max],
            newValue: [newEngineData.forward_max, newEngineData.backward_max],
        },
        vision_range: {
            label: gettext("vision range"),
            unit: gettext("m"),
            value: turretData.vision_radius,
            newValue: newTurretData.vision_radius,
        },
        moving_still_detect_range: {
            label: gettext("detection range"),
            unit: gettext("(moving/still) m"),
            separator: "/",
            value: [vehicle.data.invisibility.moving_range, vehicle.data.invisibility.still_range],
            newValue: [vehicle.data.invisibility.moving_range, vehicle.data.invisibility.still_range],
        },
    };

    Object.keys(statComponentsMap).map(componentName => {
        if (!("value" in statComponentsMap[componentName])) {
            let attributeValue = [], attributeNewValue = [];

            if ((componentName === "damage" || componentName === "piercing_power")) {
                Object.keys(gunData.shots).map(shotName => {
                    attributeValue[gunData.shots[shotName]["index"]] = gunData.shots[shotName][componentName];
                });
                Object.keys(newGunData.shots).map(shotName => {
                    attributeNewValue[newGunData.shots[shotName]["index"]] = newGunData.shots[shotName][componentName];
                });
            };
            statComponentsMap[componentName].value = attributeValue;
            statComponentsMap[componentName].newValue =  attributeNewValue ;
        }
    });

    return {configuration: configurationComponentsMap, stat: statComponentsMap};
}
